import classNames from 'classnames';
import I18n from 'i18n-js';

import { ICollectionGoals } from '@lootboy/lib/slices/cardCollections/types';

import AnimatedCheckIcon from '~/components/atoms/AnimatedCheckIcon';

import styles from './CollectionGoals.module.scss';

export function CollectionGoals({
  goals,
}: {
  goals: ICollectionGoals | null;
}): JSX.Element {
  return (
    <div className={styles.collectionGoals}>
      {goals?.reachTargetValue?.isRequired && (
        <div
          className={classNames(styles.goal, {
            [styles.fulfilled]: goals.reachTargetValue.isFulfilled,
          })}
        >
          <AnimatedCheckIcon checked={goals.reachTargetValue.isFulfilled} />
          <p>
            {I18n.t('collections_requirement_rating_bpoint', {
              n: goals.reachTargetValue.targetValue,
            })}
          </p>
        </div>
      )}
      {goals?.fillRequired?.isRequired && (
        <div
          className={classNames(styles.goal, {
            [styles.fulfilled]: goals.fillRequired.isFulfilled,
          })}
        >
          <AnimatedCheckIcon checked={goals.fillRequired.isFulfilled} />
          <p>{I18n.t('collections_requirement_cards_bpoint')}</p>
        </div>
      )}
      {goals?.fillAll?.isRequired && (
        <div
          className={classNames(styles.goal, {
            [styles.fulfilled]: goals.fillAll.isFulfilled,
          })}
        >
          <AnimatedCheckIcon checked={goals.fillAll.isFulfilled} />
          <p>{I18n.t('collections_requirement_allslots_bpoint')}</p>
        </div>
      )}
    </div>
  );
}
